import { Breadcrumbs } from "../../../../AbstractElements";
import { GalleryTitle, Href, ImageGalleryTitle } from "../../../../Constants/Constants";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { Gallery, Item } from "react-photoswipe-gallery";
import { dynamicImage, dynamicNumber } from "../../../../Utils";
import { Link } from "react-router-dom";
import { MutableRefObject } from "react";

const GalleryGridContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={GalleryTitle} parent={GalleryTitle} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={ImageGalleryTitle} />
              <CardBody className="gallery my-gallery">
                <Row className="g-3">
                  <Gallery>
                    {dynamicNumber(12).map((item, i) => (
                      <Col xl="3" md="4" xs="6" key={i} >
                        <figure>
                          <Item original={dynamicImage(`big-lightgallry/0${item}.jpg`)}>
                            {({ ref, open }) => (
                              <Link to={Href} onClick={open}>
                                <img className="img-thumbnail" ref={ref as unknown as MutableRefObject<HTMLImageElement>} src={dynamicImage(`big-lightgallry/0${item}.jpg`)} alt="Image_description" />
                              </Link>
                            )}
                          </Item>
                        </figure>
                      </Col>
                    ))}
                  </Gallery>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default GalleryGridContainer;
